import { pathname } from './path';
import { AddOnboardingSteps } from './types/add-onboarding-steps';

function addStepsForMainOnboardingPages({
  onboardingPages,
}: AddOnboardingSteps) {
  let count = 0;
  const mainOnboardingPages = Object.values(onboardingPages.main);
  mainOnboardingPages.forEach((page) => {
    count += 1;
    page['stepInStepper'] = count;
  });
}

function addStepsForExtraOnboardingPages(
  onboardingPages: Record<string, unknown>,
) {
  const mainPages = pathname.onboarding.main;
  const extraPages = pathname.onboarding.extras;
  const pages = Object.values(onboardingPages.extras);
  pages.forEach((page) => {
    let step = 0;
    switch (page.url) {
      case extraPages.storeUrl.url:
        step = mainPages.sellerId.stepInStepper;
        break;
      case extraPages.companyName.url:
        step = mainPages.product.stepInStepper;
        break;
      case extraPages.productUrl.url:
        step = mainPages.productName.stepInStepper;
    }
    page['stepInStepper'] = step;
  });
}

function addStepsForExtraOnboardingPages8Data(
  onboardingPages: Record<string, unknown>,
) {
  const mainPages = pathname.onboarding.main;
  const extraPages = pathname.onboarding.extras;
  const pages = Object.values(onboardingPages.extras);
  pages.forEach((page) => {
    let step = 0;
    switch (page.url) {
      case extraPages.storeUrl.url:
        step = mainPages.sellerId.stepInStepper;
        break;
      default:
        step = 0;
        break;
    }
    page['stepInStepper'] = step;
  });
}

export function addOnboardingStepNumbers({
  onboardingPages,
}: AddOnboardingSteps) {
  addStepsForMainOnboardingPages({
    onboardingPages,
  });
  addStepsForExtraOnboardingPages(onboardingPages);
}

export function addOnboardingStepNumbers8Data(
  onboardingPages: Record<string, unknown>,
) {
  let count = 0;
  const mainOnboardingPages = Object.values(onboardingPages.main);
  mainOnboardingPages.forEach((page) => {
    if (page.is8Data) {
      count += 1;
      page['stepInStepper'] = count;
    }
  });
  addStepsForExtraOnboardingPages8Data(onboardingPages);
}
